




import {Component, Vue, Prop} from 'vue-property-decorator';
import conf from "../config"

@Component({})
export default class KkImage extends Vue {

  @Prop({default: ''}) imageKey!:string;

  get src(){
    return`${conf.apiUrl}/image/${this.imageKey}`
  }
}
